import script from "./AppVİew.vue?vue&type=script&setup=true&lang=js"
export * from "./AppVİew.vue?vue&type=script&setup=true&lang=js"

import "./AppVİew.vue?vue&type=style&index=0&id=59eea407&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-59eea407"]])

export default __exports__